export const Experience = () => {
  const experienceData = [
    {
      company: "Sanofi",
      title: "Data Engineer",
      duration: "Sept 2025 - Present",
      description:
        "Supporting the Digital Systems & Data (DSD) team in the contextualization, engineering, and deployment of end-to-end data analytics solutions across Dev/Prod environments.",
      bullet: [
        "Self-Service Analytics Development: Spearheaded the development of the Genealogy App, a self-service data portal in Snowflake that automates cross-departmental queries and enables real-time trend analysis.",
        "ETL Pipeline Engineering: Designed and managed complex data mappings to integrate disparate data sources. Executed data pipelines, cleansing, and rigorous testing to consolidate enterprise data into a unified JMP output for advanced statistical analysis.",
        "Database Management: Designed schemas and maintained relational databases (MySQL, MSSQL, Oracle, SQLite), ensuring data integrity and optimized query performance for process data warehouse projects.",
      ],
    },
    {
      company: "Ministry of Transportation Ontario",
      title: "Junior Technical Analyst",
      duration: "Jan 2024 - April 2024",
      description:
        "Worked in the MTO data team to bridge the gap between complex datasets and business users by developing automated reporting tools and interactive intelligence dashboards.",
      bullet: [
        "Lead the development of a chatbot application for generating SQL reports queried from MTO datasets, enabling users to obtain reports without developer assistance, ultimately winning 3rd place in the OPS Microsoft Hackathon",
        "Fulfilled company data requests by querying SQL Server and building interactive, data-driven reports in Power BI based on MTO data, enabling clients to efficiently access and analyze key insights",
        "Completed work requests for companies requiring reports from MTO, by querying data in SQL Server and modeling in Power BI, creating comprehensive reports that allowed companies to easily access and analyze their required data",
      ],
    },
  ];

  return (
    <section className="experience" id="experience">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2>Work Experience</h2>
            <div className="timeline-relative">
              {/* Vertical Line */}
              <div className="timeline-border"></div>

              <ul className="timeline-list">
                {experienceData.map((exp, index) => (
                  <li key={index} className="timeline-item">
                    <div className="timeline-dot-header">
                      <div className="timeline-dot"></div>
                      <div className="timeline-company">{exp.company}</div>
                    </div>

                    <div className="timeline-body">
                      <div className="timeline-role">{exp.title}</div>
                      <div className="timeline-date">{exp.duration}</div>
                      <p className="timeline-desc">{exp.description}</p>

                      {/* Only render bullets if they exist in the data */}
                      {exp.bullet && (
                        <ul className="timeline-bullets">
                          {exp.bullet.map((item, bIndex) => (
                            <li key={bIndex}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
